import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseResourceFormComponent, FuncaoService, GlobalService, LoginContabil, Programa } from 'eddydata-lib';
import { MessageService } from 'primeng/api';
import { ProgramaService } from '../service/programa.service';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'lib-programa-form',
  templateUrl: './programa-form.component.html'
})
export class ProgramaFormComponent extends BaseResourceFormComponent<Programa, LoginContabil> implements OnInit {

  /**
   * Declaração de variáveis
   */
  @ViewChild('nome') inputField: ElementRef;

  public listaProgramas;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private messageService: MessageService,
    protected funcaoService: FuncaoService,
    protected globalService: GlobalService,
    protected programaService: ProgramaService) {
    super(new Programa(), injector, Programa.converteJson, programaService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      codigo: [null, [Validators.required]],
      nome: [null, [Validators.required]],
      descricao: [null],
      ppa: [this.login.ppa, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]]
    });
  }

  protected parametrosExtras(): {} {
    return { relations: 'ppa' };
  }

  protected afterLoad() {
    if (this.entidade?.id) {
      this.programaService.filtrar(1, -1,  { 'ppa.id': this.login.ppa.id, 'id$ne': this.entidade.id })
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(res => {
          this.listaProgramas = res.content;
        }, error => this.funcaoService.acaoErro(error))
    }
  }

  protected afterInit(): void {
    if (!this.entidade?.id) {
      this.programaService.filtrar(1, -1, { 'ppa.id': this.login.ppa.id })
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(res => {
          this.listaProgramas = res.content;
        }, error => this.funcaoService.acaoErro(error))
    }
  }

  protected campoFoco(): ElementRef {
    return this.inputField;
  }

  protected beforeSubmit() {
    const codigo = this.entidadeForm.get('codigo')?.value;
    try {
      const programaExistente = this.listaProgramas.find(p => p.codigo === codigo)
      if (programaExistente) {
        throw ('Já existe um programa com este código, para o ppa vigente!');
      }

      if (this.entidadeForm.get('nome').value === '') {
        throw new Error('Informe o nome da programa!');
      }
      this.entidadeForm.get('ppa').setValue(this.login.ppa);
    } catch (e) {
      this.messageService.add({ severity: 'error', summary: 'Validação', detail: e });
      throw e;
    }
  }

  protected afterSubmit(ent: Programa) {
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

}
